export default __webpack_public_path__ + "static/media/certif.d0ccfe8f.png";